import Vue from "vue";
import * as firebase from "firebase/app";
import { firestorePlugin } from "vuefire";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Buefy from "buefy";
import "buefy/dist/buefy.css";
import "./registerServiceWorker";

Vue.config.productionTip = false;
Vue.config.devtools = true;
Vue.use(firestorePlugin);
Vue.use(Buefy);
Vue.use(require("vue-moment"));

let app;
const initialize = () => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  }
};

export const db = firebase.firestore();
firebase.auth().onAuthStateChanged(async user => {
  try {
    if (user) {
      const res = await db
        .collection("users")
        .doc(user.uid)
        .get();
      if (res.exists) store.commit("setCurrentUser", res.data());
      else store.commit("setCurrentUser", user);
    } else {
      store.commit("setCurrentUser", null);
    }
  } catch (err) {
    console.error(err.message);
  }

  initialize();
});

export default db;
